import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdatePaymentSettingsMutation = createMutationHook(
  ShopsApiClient.updatePaymentSettings,
  {
    mutationKey: ['updatePaymentSettings'],
  },
)
